import React from "react";
import { styled } from "@material-ui/core/styles";
import { Typography, Stack, Box, Paper } from "@mui/material";
import { DocumentCard } from "../../../../components/documentCard";

const MyPaper = styled(Paper)({
  borderRadius: 8,
  borderColor: "#000",
  backgroundColor: "#F0F0F0",
  padding: "1rem",
});

const BusinessDocumentsTab = ({ kycData }) => {
  if (!kycData) {
    return null;
  }

  // Extract documents from kycData
  const documents = kycData?.documents || [];

  return (
    <>
      <Box>
        <MyPaper sx={{ flex: "1" }} elevation={0}>
          <Stack direction={"column"} spacing={2} sx={{ flex: 1 }}>
            <Stack direction={"row"}>
              <Typography mr={2} variant={"h6"}>
                Business Documents
              </Typography>
            </Stack>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 200px))",
                gridGap: "1rem",
                width: "100%",
              }}
            >
              {documents.length > 0 ? (
                documents.map((document, i) => {
                  // Handle document structure from backend
                  const docData = {
                    document: document?.file_url || document?.fileUrl || document?.url,
                    name: document?.document_type || document?.documentType || `Document ${i + 1}`,
                    document_type: document?.document_type_code || document?.documentTypeCode || document?.document_type || "--",
                  };

                  return docData.document ? (
                    <DocumentCard
                      key={document?.id || i}
                      documents={docData}
                    />
                  ) : null;
                })
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No documents submitted
                </Typography>
              )}
            </Box>
          </Stack>
        </MyPaper>
      </Box>
    </>
  );
};

export default BusinessDocumentsTab;

